import * as React from 'react';

/**
 * Detect double press (mostly for web UX).
 */
export function useDoublePress(
    onDoublePress: () => void,
    delay = 500 // default double click speed on Windows
): () => boolean {
    const lastPressRef = React.useRef(0);

    return () => {
        if (lastPressRef.current && Date.now() - lastPressRef.current < delay) {
            onDoublePress();
            lastPressRef.current = 0;

            return true;
        }
        lastPressRef.current = Date.now();

        return false;
    };
}
